<div class="p-fluid">
    <!-- <p-scrollPanel [style]="{width: '100%', height: '60vh'}"> -->
    <p-tree [value]="data" selectionMode="single" [(selection)]="selectedFile" (onNodeSelect)="nodeSelect($event)"
        (onNodeExpand)="espansioneNodo($event)">
        <ng-template let-node pTemplate="default">
            <!-- <div class="row"> -->
            <span>{{ node.label }}</span>
            <i class="fa fa-info-circle ml-4" style="font-size: 1.0em;" *ngIf="node.description != ''"
                [pTooltip]="node.description != '' ? node.description :''"></i>
            <!-- </div> -->
            <!-- <div class="row">
                <small *ngIf="node.description != ''">{{node.description}}</small>
            </div> -->
        </ng-template>
    </p-tree>
    <!-- </p-scrollPanel> -->
</div>